import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

import { removeClickOutline } from "@styles/emotion-styles/helpers/removeClickOutline";

export const accordion = css`
  > div {
    margin-right: 0;
    > div {
      padding: 0;
    }
  }
`;

export const tabHeaders = (theme: Theme) => css`
  background-color: ${theme.system.backgroundBase};
  border-radius: unset;
  & > div {
    padding: 0;
  }
`;

export const tabHeader = (theme: Theme) => css`
  transition: all 0.3s ease-out;
  color: ${theme.system.textBase};
  border-bottom: 1px solid ${theme.system.borderBase};
  height: 2.5rem;
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  min-width: max-content;
  padding: 0.5rem;
  font-weight: ${typography.weightBase};
  position: relative;

  ${removeClickOutline};

  &:hover {
    color: ${theme.system.textLabelEmphasis};
  }
  &:focus-visible {
    outline: none;
    border-color: ${theme.system.borderFocused};
  }

  &:first-of-type {
    &:after {
      content: "";
      position: absolute;
      bottom: -1px;
      left: 100%;
      height: 1px;
      width: 0.5rem;
      background-color: ${theme.system.borderBase};
      z-index: 1;
    }
  }
`;

export const tabSelected = (theme: Theme) => css`
  color: ${theme.system.textLabelEmphasis};
  border-bottom: 1px solid ${theme.system.borderActive};
  ${removeClickOutline};
`;

export const disabledTab = (theme: Theme) => css`
  color: ${theme.disabled.text};
  border-bottom: 1px solid ${theme.disabled.border};
  pointer-events: none;
  ${removeClickOutline};
`;
